<template>
  <section v-bind="sectionProps">
    <v-navigation-drawer
      v-model="drawer"
      v-bind="drawerProps"
      v-scroll="handleScroll"
      v-if="$store.state.editor.drawer.type != 'section-builder'"
    >
      <base-mobile-menu
        :menu="section.content['menu']"
        :props="menuItemProps"
      ></base-mobile-menu>
    </v-navigation-drawer>

    <header v-bind="headerProps" ref="headerWrapper">
      <v-container v-bind="containerProps" class="py-0" ref="headerContainer">
        <v-row v-bind="rowProps">
          <v-col v-bind="logoColumnProps" v-if="section.content['logo']">
            <v-card v-bind="logoProps" @click="$vuetify.goTo(0)">
              <img v-bind="logoImageProps" v-if="section.content['logo']" />
            </v-card>
          </v-col>

          <v-spacer></v-spacer>

          <v-col v-bind="menuColumnProps">
            <base-menu
              :menu="section.content['menu']"
              :props="menuItemProps"
            ></base-menu>
          </v-col>

          <v-fade-transition>
            <v-btn v-bind="mobileToggleProps" @click="drawer = true">
              <v-icon>mdi-menu</v-icon>
            </v-btn>
          </v-fade-transition>
        </v-row>
      </v-container>

      <div v-bind="headerBackgroundProps"></div>

      <slot name="toolbar"></slot>
    </header>

    <!-- TODO - Fix multiple sticky headers -->
    <v-slide-y-transition>
      <header
        v-show="showStickyHeader"
        v-bind="stickyHeaderProps"
        v-if="isSticky"
      >
        <v-container v-bind="containerProps" class="py-0">
          <v-row v-bind="rowProps">
            <v-col v-bind="stickyLogoColumnProps">
              <v-card v-bind="logoProps" @click="$vuetify.goTo(0)">
                <img v-bind="logoImageProps" v-if="section.content['logo']" />
              </v-card>
            </v-col>

            <v-spacer></v-spacer>

            <v-col v-bind="stickyMenuColumnProps">
              <base-menu
                :menu="section.content['menu']"
                :props="menuItemProps"
              ></base-menu>
            </v-col>

            <v-fade-transition>
              <v-btn v-bind="mobileToggleProps" @click="drawer = true">
                <v-icon>mdi-menu</v-icon>
              </v-btn>
            </v-fade-transition>
          </v-row>
        </v-container>

        <div v-bind="stickyHeaderBackgroundProps"></div>
      </header>
    </v-slide-y-transition>

    <header
      v-bind="stickyHeaderProps"
      v-if="isSticky"
      ref="stickyHeaderDummy"
      style="margin-top: -200%;"
    >
      <v-container v-bind="containerProps" class="py-0">
        <v-row v-bind="rowProps">
          <v-col v-bind="stickyLogoColumnProps">
            <v-card v-bind="logoProps" @click="$vuetify.goTo(0)">
              <img
                v-bind="logoImageProps"
                v-if="section.content['logo']"
                @load="setStickyHeaders"
              />
            </v-card>
          </v-col>

          <v-spacer></v-spacer>

          <v-col v-bind="stickyMenuColumnProps">
            <base-menu
              :menu="section.content['menu']"
              :props="menuItemProps"
            ></base-menu>
          </v-col>

          <v-fade-transition>
            <v-btn v-bind="mobileToggleProps" @click="drawer = true">
              <v-icon>mdi-menu</v-icon>
            </v-btn>
          </v-fade-transition>
        </v-row>
      </v-container>

      <div v-bind="stickyHeaderBackgroundProps"></div>
    </header>
  </section>
</template>

<script>
import BaseMenu from '@/components/sections/partials/menu/BaseMenu'
import BaseMobileMenu from '@/components/sections/partials/menu/BaseMobileMenu'

export default {
  name: 'NavigationDefaultSection',
  props: {
    section: {
      type: Object,
      required: true
    },
    templateSettings: {
      type: Object,
      required: true
    },
    builder: {
      type: Boolean,
      default: true
    }
  },
  components: {
    BaseMenu,
    BaseMobileMenu
  },
  data: () => ({
    showStickyHeader: false,
    drawer: false
  }),
  computed: {
    absoluteHeight() {
      if (
        this.parseBoolean(this.section.layout['absolute']) &&
        this.$store.state.editor.drawer.type != 'section-builder' &&
        this.$refs.headerWrapper
      ) {
        return this.$refs.headerWrapper.clientHeight + 'px'
      } else {
        return 'auto'
      }
    },
    sectionProps() {
      return {
        class: ['pa-0'],
        style: {
          height: this.absoluteHeight,
          marginBottom:
            this.absoluteHeight == 'auto' ? '0' : `-${this.absoluteHeight}`,
          backgroundColor: 'transparent'
        }
      }
    },
    headerProps() {
      return {
        style: {
          color: this.section.design['menu-text-color'],
          fontFamily: this.section.design['menu-font-family'],
          paddingTop: this.section.design['padding'],
          paddingBottom: this.section.design['padding'],
          position:
            this.parseBoolean(this.section.layout['absolute']) &&
            this.$store.state.editor.drawer.type != 'section-builder'
              ? 'absolute'
              : 'static',
          zIndex:
            this.parseBoolean(this.section.layout['absolute']) &&
            this.$store.state.editor.drawer.type != 'section-builder'
              ? 100
              : 'inherit',
          top:
            this.parseBoolean(this.section.layout['absolute']) &&
            this.$store.state.editor.drawer.type != 'section-builder'
              ? '0'
              : 'auto',
          width:
            this.parseBoolean(this.section.layout['absolute']) &&
            this.$store.state.editor.drawer.type != 'section-builder'
              ? '100%'
              : 'auto'
        }
      }
    },
    headerBackgroundProps() {
      return {
        style: {
          position: 'absolute',
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 0,
          backgroundColor: this.section.design['background-color'],
          opacity: this.parseBoolean(this.section.layout['absolute'])
            ? this.section.layout['absolute-background-opacity']
            : '1'
        }
      }
    },
    stickyHeaderProps() {
      return {
        style: {
          color: this.section.design['menu-text-color'],
          fontFamily: this.section.design['menu-font-family'],
          paddingTop: '10px',
          paddingBottom: '10px',
          position: 'fixed',
          zIndex: 200,
          top: 0,
          width: '100%'
        }
      }
    },
    stickyHeaderBackgroundProps() {
      return {
        style: {
          position: 'absolute',
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 0,
          backgroundColor: this.section.advanced['sticky-background-color'],
          opacity: this.section.advanced['sticky-background-opacity']
        }
      }
    },
    stickyLogoColumnProps() {
      return {
        cols: 'auto',
        align: 'left'
      }
    },
    stickyMenuColumnProps() {
      return {
        cols:
          this.parseBoolean(this.section.layout['centered']) &&
          !this.mobileToggleVisible &&
          !this.section.content['logo']
            ? '12'
            : 'auto',
        align:
          this.parseBoolean(this.section.layout['centered']) &&
          !this.mobileToggleVisible &&
          !this.section.content['logo']
            ? 'center'
            : 'right',
        class: [
          this.section.layout['show-toggle'] == 'xs'
            ? 'hidden-xs-only'
            : this.section.layout['show-toggle'] == 'none'
            ? ''
            : `hidden-${this.section.layout['show-toggle']}-and-down`,
          this.section.layout['show-toggle'] == 'lg' ? 'd-none' : ''
        ]
      }
    },
    drawerProps() {
      return {
        fixed: true,
        temporary: true,
        right: true,
        style: {
          backgroundColor: this.section.design['background-color'],
          color: this.section.design['menu-text-color'],
          fontFamily: this.section.design['menu-font-family'],
          paddingTop: this.section.design['padding'],
          paddingBottom: this.section.design['padding'],
          zIndex: 1000
        }
      }
    },
    containerProps() {
      return {
        fluid: this.parseBoolean(
          this.section.layout['content-container-fluid']
        ),
        style: {
          position: 'relative',
          zIndex: 1
        }
      }
    },
    rowProps() {
      return {
        'no-gutters': true,
        align: 'center'
      }
    },
    logoProps() {
      return {
        to: '/',
        ripple: false,
        flat: true,
        tile: true,
        style: {
          backgroundColor: 'transparent',
          textTransform: 'none',
          color: this.section.design['menu-text-color']
        }
      }
    },
    logoImageProps() {
      return {
        ripple: false,
        class: {
          'mr-5': this.section.content['logo-text']
        },
        width: this.section.design['logo-width'],
        contain: true,
        src: this.loadMedia(this.section.content['logo']),
        'lazy-src': this.loadMedia(this.section.content['logo'], 'thumbnail')
      }
    },
    logoColumnProps() {
      return {
        cols:
          this.parseBoolean(this.section.layout['centered']) &&
          !this.mobileToggleVisible
            ? '12'
            : 'auto',
        align:
          this.parseBoolean(this.section.layout['centered']) &&
          !this.mobileToggleVisible
            ? 'center'
            : 'left',
        style: {
          paddingBottom:
            this.parseBoolean(this.section.layout['centered']) &&
            !this.mobileToggleVisible
              ? '20px'
              : 0,
          paddingTop:
            this.parseBoolean(this.section.layout['centered']) &&
            !this.mobileToggleVisible
              ? '15px'
              : 0
        }
      }
    },
    menuColumnProps() {
      return {
        cols:
          this.parseBoolean(this.section.layout['centered']) &&
          !this.mobileToggleVisible
            ? '12'
            : 'auto',
        align:
          this.parseBoolean(this.section.layout['centered']) &&
          !this.mobileToggleVisible
            ? 'center'
            : 'right',
        class: [
          this.section.layout['show-toggle'] == 'xs'
            ? 'hidden-xs-only'
            : this.section.layout['show-toggle'] == 'none'
            ? ''
            : `hidden-${this.section.layout['show-toggle']}-and-down`,
          this.section.layout['show-toggle'] == 'lg' ? 'd-none' : ''
        ]
      }
    },
    menuItemProps() {
      return {
        ripple: false,
        class: [`menu-active-style-${this.section.advanced['active-style']}`],
        tile: true,
        text: true,
        style: {
          fontSize: this.section.design['menu-font-size'],
          textTransform: 'none',
          color: this.section.design['menu-text-color']
        }
      }
    },
    mobileToggleProps() {
      return {
        icon: true,
        ripple: false,
        class: ['ma-0', this.mobileToggleClass],
        style: {
          color: this.section.design['menu-text-color']
        }
      }
    },
    mobileToggleClass() {
      switch (this.section.layout['show-toggle']) {
        case 'xs':
          return 'hidden-sm-and-up'
        case 'sm':
          return 'hidden-md-and-up'
        case 'md':
          return 'hidden-lg-and-up'
        case 'lg':
          return ''
        case 'xl':
          return ''
        case 'none':
          return 'd-none'
        default:
          return 'hidden-md-and-up'
      }
    },
    mobileToggleVisible() {
      switch (this.section.layout['show-toggle']) {
        case 'xs':
          return this.screenSize == 'xs'
        case 'sm':
          return this.screenSize == 'sm' || this.screenSize == 'xs'
        case 'md':
          return (
            this.screenSize == 'md' ||
            this.screenSize == 'sm' ||
            this.screenSize == 'xs'
          )
        case 'lg':
          return true
        case 'none':
          return false
        default:
          return true
      }
    },
    isSticky() {
      // only allow one header to be sticky
      return (
        this.parseBoolean(this.section.advanced['stick-on-scroll']) &&
        (this.$store.state.section.stickyHeader.id == null ||
          this.$store.state.section.stickyHeader.id == this.section.id) &&
        this.$store.state.editor.drawer.type != 'section-builder'
      )
    }
  },
  methods: {
    handleScroll() {
      let headerEl = this.$refs.headerWrapper

      if (
        headerEl.getBoundingClientRect().y + headerEl.clientHeight + 100 < 0 &&
        (!this.isLoggedIn ||
          (this.isLoggedIn && this.currentUser.mode !== 'editor')) &&
        this.isSticky
      ) {
        this.showStickyHeader = true
      } else {
        this.showStickyHeader = false
      }
    },
    setStickyHeaders() {
      this.$nextTick(() => {
        if (this.isSticky) {
          this.$store.commit('section/SET_STICKY_HEADER', {
            id: this.section.id,
            height: this.$refs.stickyHeaderDummy.clientHeight
          })
        }
      })
    }
  },
  mounted() {
    this.setStickyHeaders()
  }
}
</script>
